import Map from "./Map";
import { Dealer } from "../data/models";
import WorkingHours from "./WorkingHours";
import Button from "./Button";

export interface StoreInfoProps {
  dealer: Dealer;
}

export function StoreInfo(props: StoreInfoProps) {
  const { dealer } = props;
  return (
    <div className="flex flex-col sm:flex-row justify-between p-6 gap-[40px] lg:gap-[60px] bg-gray-extra-dark">
      <div className="flex flex-col flex-1 gap-8 lg:gap-[60px] lg:flex-row">
        <div className="flex flex-col flex-1 gap-4 lg:gap-6">
          <h3 className="text-lg font-bold uppercase text-primary-white">
            Distributer
          </h3>
          <hr className="w-full border-t-1 border-line-gray" />

          <div className="flex flex-col gap-4">
            <div className="flex flex-col justify-between gap-3">
              <h4 className="text-md text-primary-white">{dealer.name}</h4>
              <span className="text-sm text-primary-white text-opacity-80">
                {dealer.street && (
                  <>
                    {dealer.street},&nbsp;{dealer.postal_code}&nbsp;
                    {dealer.city}
                  </>
                )}
              </span>
            </div>
          </div>
          <a href={dealer.url} target="_blank" rel="noopener noreferrer">
            <Button
              text="Posjetite stranicu distributera"
              variant="secondaryLight"
              size="base"
            />
          </a>
        </div>

        <div className="flex flex-col flex-1 gap-4 lg:gap-6">
          <h3 className="text-lg font-bold uppercase text-primary-white">
            Radno vrijeme
          </h3>
          <hr className="w-full border-t-1 border-line-gray" />

          {dealer.working_hours.monday ? (
            <div className="flex flex-col gap-3">
              <WorkingHours day="pon" hours={dealer.working_hours.monday} />
              <WorkingHours day="uto" hours={dealer.working_hours.tuesday} />
              <WorkingHours day="sri" hours={dealer.working_hours.wednesday} />
              <WorkingHours day="čet" hours={dealer.working_hours.thursday} />
              <WorkingHours day="pet" hours={dealer.working_hours.friday} />
              <WorkingHours day="sub" hours={dealer.working_hours.saturday} />
              <WorkingHours day="ned" hours={dealer.working_hours.sunday} />
            </div>
          ) : (
            <div className="text-sm f text-primary-white text-opacity-80">
              Trenutno nema informacija o radnom vremenu.
            </div>
          )}
        </div>
      </div>
      <div className="lg:w-[601px] lg:h-[388px] sm:w-[313px] sm:h-[486px] h-[250px]">
        <Map
          city={dealer.city}
          street={dealer.street}
          postalCode={dealer.postal_code}
          dealer={dealer.name}
        ></Map>
      </div>
    </div>
  );
}

export default StoreInfo;
